import * as Yup from 'yup';

import { globalMessages } from '@savgroup-front-common/core/helpers';

const claimGroupSolutionSchema = Yup.object().shape({
  chooseSolution: Yup.string().required(globalMessages.form.required),
});

export default claimGroupSolutionSchema;
